"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = require("../constants/index.js");
var _index2 = require("../utils/index.js");
var OFFER = _index.urlParams.OFFER;
var getOffersFromDOM = function getOffersFromDOM() {
  return (0, _index2.extractParamValuesFromDOM)(OFFER);
};
var _default = exports["default"] = getOffersFromDOM;